import { provider } from '@/provider.js'
import cfg from '@/cfg'

export default {
  async setCurrentlySelectedUser({ commit }, userId) {
    commit('requestSelectedUser')
    const user = await provider.findUser(userId)
    commit('setCurrentlySelectedUser', user)
    commit('receiveSelectedUser')
  },
  async getAuthToken({ commit }, user) {
    const response = await provider.getMapper("user").getAuthenticationToken(user.id)
    const authToken = response.data.authentication_token
    commit('setUserAuthToken', { user, authToken })
  },
  async updateUser({ commit }, user) {
    const response = await provider.updateUser(user)
    if (response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
    } else {
      commit("displayFlashMessage", { message: "User saved.", severity: "success" })
    }
    return response
  },
  async updateUserWithPassword({ commit }, user) {
    const response = await provider.updateUserWithPassword(user)
    if (response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
    } else {
      commit("displayFlashMessage", { message: "User saved.", severity: "success" })
    }
    return response
  },
  async setupMFA({ commit }, user) {
    const response = await provider.setupMFA(user)
    if (response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
    } else {
      commit("mfaEnabledForUser")
      commit("displayFlashMessage", { message: "MFA setup and enabled.", severity: "success" })
    }
    return response
  },
  async disableMFA({ commit }, user) {
    const response = await provider.disableMFA(user)
    if (response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
    } else {
      commit("mfaDisabledForUser")
      commit("displayFlashMessage", { message: "MFA disabled.", severity: "success" })
    }
    return response
  },  
  async deleteUser({ commit }, user) {
    const response = await provider.deleteUser(user)
    if (response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
      return false
    } else {
      commit("removeUser", user)
      commit("displayFlashMessage", { message: "User deleted.", severity: "success" })
      return true
    }
  },
  async createUser({ commit }, user) {
    try {
      const result = await provider.createUser(user)
      if (result.error) {
        commit("displayFlashMessage", {
          message: result.message || "Could not invite user.",
          severity: "error",
        })
        return result
      }
      commit("newUser", result.user)
      return result
    } catch (err) {
      const message = (err && err.message) || "Could not invite user."
      commit("displayFlashMessage", { message, severity: "error" })
      return { error: true, message }
    }
  },
  updatePassword({ commit, state }, data) {
    if (data.confirmation === data.password) {
      const newData = Object.assign({}, state.currentlySelected.user)
      newData.password = data.password
      commit('updatePassword', data)
    }
  },
  async updateAvatar({ commit }, data) {
    const formData = new FormData()
    formData.append("new_logo_file", data.imgFile)
    const url = `${cfg.apiEndPoint()}users/avatar/${data.user.account_id}/${data.user.id}`
    const result = await fetch(url,
      {
        method: 'POST',
        body: formData,
        headers: {
          auth_token: data.authToken
        }
      })
    const output = await result.json()
    const imageUri = new URL(output.url, cfg.apiEndPoint())
    commit('setUserAvatarUrl', imageUri.toString())
  },
  clearAvatar({ commit }) {
    commit('setUserAvatarUrl', null)
  }
}
